
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import InputPositiveNumbers from '@/components/UI/InputPositiveNumbers.vue';
import Button from '@/components/UI/button/Button.vue';
import StopDrawing from '@/components/jobDetailed/StopDrawing/StopDrawing.vue';
import DateTimezoneToggle from '@/components/UI/dateTimezoneToggle/DateTimezoneToggle.vue';
import { uuidv4 } from '@/utils/Common';
import {
  AirRoadBookingProductChoosenData,
  AirRoadBookingProductRemoving,
  AirRoadJobData,
  AirRoadJobPackageData,
  AirRoadJobProductData,
  AirRoadProductDroppedOnPackageData,
} from '@/models/airRoad';

@Component({
  components: { DateTimezoneToggle, StopDrawing, Button, InputPositiveNumbers },
})
export default class PackageStep extends Vue {
  @Prop(Boolean) loading!: boolean;
  @Prop(Array) jobsToBook!: Array<AirRoadJobData>;
  @Prop(Array) productsToDrop!: Array<AirRoadJobProductData>;
  @Prop(Array) productsPacked!: Array<AirRoadJobPackageData>;

  public selectedProduct = null;
  public productDefaultData = {
    _id: 0,
    serial: '',
    model: '',
    description: '',
    quantity: 0,
    goods_code: '',
    weight: 0,
    volume: '',
    length: 0,
    width: 0,
    height: 0,
    quant_id: 0,
    from_stop: 0,
    to_stop: 0,
  };
  // Packages data
  public productDroppedOnPackage: AirRoadProductDroppedOnPackageData = {
    counter: 0,
    counterMax: 0,
    data: {
      ...this.productDefaultData,
    },
  };
  public productChosen: AirRoadBookingProductChoosenData = {
    cartonEditing: false,
    palletEditing: false,
    split: false,
    splitCounter: 1,
    data: {
      event: {
        product: { ...this.productDefaultData },
      },
      type: 'none',
    },
  };
  public productExtra = {
    model: 'Extra product',
    volume: 0.048,
    weight: 0.1,
  };
  // Total
  public totalPackagesData = {
    carton: {
      quantity: 0,
      value: 0,
      weight: 0,
    },
    pallet: {
      quantity: 0,
      value: 0,
      weight: 0,
    },
  };
  public calcOpen = '';
  public calcData = {
    width: 40,
    height: 40,
    length: 30,
    value: 0.048,
  };
  public productRemoving: AirRoadBookingProductRemoving = {
    quantity: 0,
    data: {
      ...this.productDefaultData,
    },
  };

  public packageDimensionsValues = {
    0: {
      width: 90,
      height: 90,
      length: 120,
      chosen: false,
    },
    1: {
      width: 40,
      height: 40,
      length: 30,
      chosen: true,
    },
    2: {
      width: 10,
      height: 10,
      length: 30,
      chosen: false,
    },
    3: {
      width: 0,
      height: 0,
      length: 0,
      chosen: false,
      custom: true,
    },
  };
  backBtnClicked() {
    this.$emit('backBtnClicked');
  }

  nextStepClick() {
    this.$emit('nextStepClick');
  }

  public packEachToClick(type: string): void {
    this.productsToDrop.map(productToDrop => {
      const addingWeight = (Number(productToDrop.weight) * productToDrop.quantity).toFixed(2);
      const packageCounter = this.productsPacked.filter(x => x.type === type).length;
      // Defaults: carton - 40x40x40, pallet – 90x90x120
      this.productsPacked.unshift({
        id: uuidv4(),
        name: `${type.charAt(0).toUpperCase() + type.slice(1)} #${packageCounter + 1}`,
        type: type,
        weight: String(addingWeight),
        width: productToDrop.width,
        height: productToDrop.height,
        length: productToDrop.length,
        value: Number(productToDrop.volume),
        template: 'default',
        weightDialogIsOpen: false,
        weightIsEdited: false,
        weightEditedValue: 0,
        items: [
          {
            ...productToDrop,
            quantity: productToDrop.quantity,
          },
        ],
      });
    });
    this.productsToDrop.length = 0;
  }

  public onDragStart(event, product) {
    this.selectedProduct = product;
    event.product = product;
  }

  public onDragEnd() {
    this.selectedProduct = null;
  }
  // Empty
  public handleDrop(data) {
    data.event.product = this.selectedProduct;
    if (data.type === 'carton') {
      this.productChosen.cartonEditing = true;
      this.productChosen.palletEditing = false;
    }
    if (data.type === 'pallet') {
      this.productChosen.palletEditing = true;
      this.productChosen.cartonEditing = false;
    }
    this.productChosen.split = false;
    this.productChosen.splitCounter = 1;
    this.productChosen.data = data;
    this.productChosen.data.event.product.counterMax = this.productChosen.data.event.product.quantity;
    this.productChosen.data.event.product.counterChanging = this.productChosen.data.event.product.quantity;
  }
  // On package
  public handlePackageDrop(event, product) {
    event.product = this.selectedProduct;
    this.productDroppedOnPackage.data = event.product;
    this.productDroppedOnPackage.counter = event.product.quantity;
    this.productDroppedOnPackage.counterMax = product.items[0].counterMax;
    product.template = 'addToPackage';
  }

  // CLOSING
  public packageCloseClicked(product: AirRoadJobPackageData) {
    product.template = 'unpackPackage';
  }
  public productChosenCloseClick() {
    this.productChosen.cartonEditing = false;
    this.productChosen.palletEditing = false;
    Object.values(this.packageDimensionsValues).map(val => (val.chosen = false));
    this.packageDimensionsValues[1].chosen = true;
    this.calcData = {
      width: 40,
      height: 40,
      length: 30,
      value: 0.048,
    };
  }
  // UNPACKING
  // Show template
  public unpackProductClick(product, item) {
    // Show unpacking template
    if (product.items.length - item.quantity === 0) {
      product.template = 'unpackPackage';
    } else {
      product.template = 'unpackProduct';
    }
    // unpackPackage
    this.productRemoving.data = item;
    this.productRemoving.quantity = item.quantity;
  }
  // Unpack
  public unpackPackageClick(product: AirRoadJobPackageData) {
    product.items.map(item => {
      const itemIdx = this.productsToDrop.findIndex(x => x._id === item._id && x.model === item.model);
      if (itemIdx >= 0) {
        this.productsToDrop[itemIdx].quantity = Number(this.productsToDrop[itemIdx].quantity) + Number(item.quantity);
      } else {
        this.productsToDrop.push(item);
      }
    });
    const productIdx = this.productsPacked.findIndex(x => x.id === product.id);
    if (productIdx >= 0) {
      this.productsPacked.splice(productIdx, 1);
    }
    this.updatePackagesCounters();
  }
  // Product
  public unpackProductBtnClick(product) {
    // Show "remove all" template if removing all the products
    if (product.items.length === 1 && this.productRemoving.quantity === this.productRemoving.data.quantity) {
      product.template = 'unpackPackage';
    } else {
      const itemIdx = this.productsToDrop.findIndex(x => x._id === this.productRemoving.data._id);
      // Update counter if exist
      if (itemIdx >= 0) {
        this.productsToDrop[itemIdx].quantity =
          Number(this.productsToDrop[itemIdx].quantity) + Number(this.productRemoving.quantity);
      } else {
        // Add to the productsToDrop if not
        this.productsToDrop.push({ ...this.productRemoving.data, quantity: this.productRemoving.quantity });
      }
      // Recalc Weight & Volume (value)
      const currentItemIdx = product.items.findIndex(x => x._id === this.productRemoving.data._id);
      if (currentItemIdx >= 0) {
        if (product.items[currentItemIdx].quantity <= this.productRemoving.quantity) {
          product.items.splice(currentItemIdx, 1);
        } else {
          product.items[currentItemIdx].quantity =
            Number(product.items[currentItemIdx].quantity) - Number(this.productRemoving.quantity);
        }
        let productWeight = 0;
        product.items.map(item => {
          productWeight += Number(item.weight) * Number(item.quantity);
        });
        product.weight = productWeight.toFixed(2);
      }
      // Change template
      product.template = 'default';
      this.updatePackagesCounters();
    }
  }

  get calcDataDimensions(): number {
    return Math.ceil(((this.calcData.width * this.calcData.height * this.calcData.length) / 1000000) * 1000) / 1000;
  }

  // Open "change weight" dialog
  public openEditPackageWeightClicked(product): void {
    const filtered = this.productsPacked.filter(x => x !== product);
    filtered.map(product => {
      product.weightDialogIsOpen = false;
    });
    product.weightDialogIsOpen = !product.weightDialogIsOpen;
  }

  // "change weight" clicked
  public changePackageWeightClicked(product): void {
    product.weightIsEdited = true;
    product.weightDialogIsOpen = false;
  }

  public packageWeightChanged(value, id) {
    const product = this.productsPacked.find(x => x.id === id);
    if (product) {
      product.weightEditedValue = value;
    }
  }

  // ADDING
  // PRODUCT
  public addProductBtnClick(product: AirRoadJobPackageData) {
    const productIdx = product.items.findIndex(
      x => x._id === this.productDroppedOnPackage.data._id && x.model === this.productDroppedOnPackage.data.model,
    );
    if (productIdx >= 0) {
      product.items[productIdx].quantity =
        Number(product.items[productIdx].quantity || product.items[productIdx].quantity) +
        Number(this.productDroppedOnPackage.counter);
    } else {
      product.items.push({
        ...this.productDroppedOnPackage.data,
        quantity: this.productDroppedOnPackage.counter,
      });
    }

    let productWeight = 0;
    product.items.map(item => {
      productWeight += Number(item.weight) * Number(item.quantity);
    });

    product.template = 'default';
    const productToDropIdx = this.productsToDrop.findIndex(x => x._id === this.productDroppedOnPackage.data._id);
    if (productToDropIdx >= 0) {
      product.weight = productWeight.toFixed(2);
      if (this.productsToDrop[productToDropIdx].quantity <= this.productDroppedOnPackage.counter) {
        this.productsToDrop.splice(productToDropIdx, 1);
      } else {
        this.productsToDrop[productToDropIdx].quantity =
          Number(this.productsToDrop[productToDropIdx].quantity) - Number(this.productDroppedOnPackage.counter);
      }
    }
  }

  // Extra product:
  public addExtraProductClick(): void {
    this.productsToDrop.push({
      ...this.productExtra,
      _id: Math.floor(100000 + Math.random() * 900000),
      serial: '',
      description: '',
      quantity: 1,
      goods_code: '',
      volume: String(this.productExtra.volume),
      length: 30,
      width: 40,
      height: 40,
      quant_id: 0,
      from_stop: this.jobsToBook[0].leg_2_chosen ? 2 : 1,
      to_stop: this.jobsToBook[0].leg_2_chosen ? 3 : 2,
      extra: true,
    });
  }

  public cubicWeight(weight: number): number {
    return weight * 250;
  }

  public removeExtraProductClick(product): void {
    const productToDropIdx = this.productsToDrop.findIndex(x => x._id === product._id);
    if (productToDropIdx >= 0) {
      this.productsToDrop.splice(productToDropIdx, 1);
    }
  }

  public addPackageDimensionsChanged(event) {
    const chosenValue = this.packageDimensionsValues[event.target.value];
    Object.keys(this.packageDimensionsValues).map(key => (this.packageDimensionsValues[key].chosen = false));
    chosenValue.chosen = true;
    if (chosenValue) {
      this.calcData.width = chosenValue.width;
      this.calcData.height = chosenValue.height;
      this.calcData.length = chosenValue.length;
      this.calcData.value = this.calcDataDimensions;
    }
    if (chosenValue.custom) {
      this.calcOpen = 'carton';
    }
  }
  //  PACKAGE
  // Recalc packet products counter
  public updatePackagesCounters(): void {
    this.productsPacked
      .filter(x => x.type === 'carton')
      .map((product, idx) => {
        product.name = `Carton #${idx + 1}`;
      });

    this.productsPacked
      .filter(x => x.type === 'pallet')
      .map((product, idx) => {
        product.name = `Pallet #${idx + 1}`;
      });
  }
  //
  public addPackage(product) {
    const changingProductIdx = this.productsToDrop.findIndex(
      x => x.model === product.data.event.product.model && x.serial === product.data.event.product.serial,
    );
    if (changingProductIdx >= 0) {
      // this.productsToDrop[changingProductIdx].value = this.calcData.value;
      this.productsToDrop[changingProductIdx].volume = String(this.calcData.value);
      if (
        Number(this.productsToDrop[changingProductIdx].quantity) <= Number(product.data.event.product.counterChanging)
      ) {
        this.productsToDrop.splice(changingProductIdx, 1);
      } else {
        this.productsToDrop[changingProductIdx].quantity =
          Number(this.productsToDrop[changingProductIdx].quantity) - Number(product.data.event.product.counterChanging);
      }
    }
    let type = '';
    if (product.cartonEditing) {
      type = 'carton';
    }
    if (product.palletEditing) {
      type = 'pallet';
    }

    const addingWeight = (
      Number(product.data.event.product.weight) * product.data.event.product.counterChanging
    ).toFixed(2);

    // Update counters & names
    this.updatePackagesCounters();

    if (!product.split) {
      const packageCounter = this.productsPacked.filter(x => x.type === type).length;
      this.productsPacked.unshift({
        id: uuidv4(),
        name: `${type.charAt(0).toUpperCase() + type.slice(1)} #${packageCounter + 1}`,
        type: type,
        weight: String(addingWeight),
        width: this.calcData.width,
        height: this.calcData.height,
        length: this.calcData.length,
        value: this.calcData.value,
        template: 'default',
        weightDialogIsOpen: false,
        weightIsEdited: false,
        weightEditedValue: 0,
        items: [
          {
            ...product.data.event.product,
            quantity: product.data.event.product.counterChanging,
          },
        ],
      });
    } else {
      const full = Math.ceil(product.data.event.product.counterChanging / this.productChosen.splitCounter);
      for (let i = 0; i < this.productChosen.splitCounter - 1; i++) {
        const packageCounter = this.productsPacked.filter(x => x.type === type).length;
        this.productsPacked.unshift({
          id: uuidv4(),
          name: `${type.charAt(0).toUpperCase() + type.slice(1)} #${packageCounter + 1}`,
          type: type,
          weight: (Number(product.data.event.product.weight) * full).toFixed(2),
          width: Number(this.calcData.width.toFixed(2)),
          height: Number(this.calcData.height.toFixed(2)),
          length: Number(this.calcData.length.toFixed(2)),
          value: Number(this.calcData.value.toFixed(2)),
          template: 'default',
          weightDialogIsOpen: false,
          weightIsEdited: false,
          weightEditedValue: 0,
          items: [
            {
              ...product.data.event.product,
              quantity: full,
            },
          ],
        });
      }
      if (product.data.event.product.counterChanging - full * (this.productChosen.splitCounter - 1) >= 1) {
        const packageCounter = this.productsPacked.filter(x => x.type === type).length;
        const count = product.data.event.product.counterChanging - full * (this.productChosen.splitCounter - 1);
        this.productsPacked.unshift({
          id: uuidv4(),
          name: `${type.charAt(0).toUpperCase() + type.slice(1)} #${packageCounter + 1}`,
          type: type,
          width: product.data.event.product.width,
          height: product.data.event.product.height,
          length: product.data.event.product.length,
          value: Number(this.calcData.value.toFixed(2)),
          weight: (Number(product.data.event.product.weight) * count).toFixed(2),
          template: 'default',
          weightDialogIsOpen: false,
          weightIsEdited: false,
          weightEditedValue: 0,
          items: [
            {
              ...product.data.event.product,
              quantity: count,
            },
          ],
        });
      }
    }

    this.productChosen.cartonEditing = false;
    this.productChosen.palletEditing = false;
  }

  public addPackageDrop(data) {
    this.handleDrop(data);
    this.addPackage(this.productChosen);
  }

  // TABLE CALC
  public calcClicked(name): void {
    this.calcOpen = name;
  }
  public calcCloseClicked(): void {
    this.calcOpen = '';
  }
  public calcChanged(): void {
    Object.keys(this.packageDimensionsValues).map(key => (this.packageDimensionsValues[key].chosen = false));
    this.packageDimensionsValues[3].chosen = true;
    // limiting calc inputs length to 5
    Object.values(this.calcData).map((dimension, idx) => {
      if (String(dimension).length >= 5) {
        this.calcData[Object.keys(this.calcData)[idx]] = Number(String(dimension).slice(0, -1));
      }
    });
    this.calcData.value = this.calcDataDimensions;
  }

  // TOTAL TABLE:
  public calcPackagesTotal() {
    // Set total to null
    // TODO: move to global?
    Object.keys(this.totalPackagesData).map(typeKey => {
      Object.keys(this.totalPackagesData[typeKey]).map(valueKey => {
        this.totalPackagesData[typeKey][valueKey] = 0;
      });
    });
    // Calc values
    this.productsPacked.map(product => {
      // Quantity
      this.totalPackagesData[product.type].quantity += 1;
      // Volume
      const newValue =
        (Math.ceil(this.totalPackagesData[product.type].value * 1000) + Math.ceil(product.value * 1000)) / 1000;
      this.totalPackagesData[product.type].value = newValue;
      // Weight
      const curWeight = product.weightIsEdited ? product.weightEditedValue : Number(product.weight);
      this.totalPackagesData[product.type].weight =
        (Math.ceil(this.totalPackagesData[product.type].weight * 1000) + Math.ceil(curWeight * 1000)) / 1000;
    });
  }

  onmounted() {
    this.productDroppedOnPackage = {
      counter: 0,
      counterMax: 0,
      data: {
        ...this.productDefaultData,
      },
    };
    this.productsPacked = [];
  }

  // Packed total
  @Watch('productsPacked', { deep: true })
  private productsPackedChanged() {
    this.calcPackagesTotal();
  }
}
